import { CONCURRENCY_OPTIONS, QUALITY_OPTIONS } from './constants';
import { events } from './events';
import { Module } from './framework/module';
import { store } from './store';

export class ControlsModule extends Module {
  private openInput$ = document.querySelector<HTMLInputElement>('#open-input');
  private intro$ = document.querySelector<HTMLDivElement>('#intro');

  constructor() {
    super({});
  }

  async onInit() {
    this.intro$?.addEventListener('click', () => this.onOpenClick());
    this.openInput$?.addEventListener('change', (event) =>
      this.onOpenInput(event)
    );

    events.on('open', (event) => this.onOpen(event));
  }

  private onOpenInput(ev: Event) {
    var target = ev?.target as HTMLInputElement;
    if (!target?.files?.length) {
      return;
    }

    events.emit('open', { files: target.files });
  }

  private onOpenClick() {
    this.openInput$?.click();
  }

  private onOpen({ files }) {
    events.emit('convert', {
      files,
      quality: store.get('quality') || QUALITY_OPTIONS[0],
      concurrency: store.get('concurrency') || CONCURRENCY_OPTIONS[0],
    });
  }
}
